var nurseslounge_job_jobDetail = {
    init:function($params, cback){
        $params = $.extend({},$params, {action:'info',tab:'job_init'});
        nurseslounge_job_jobDetail.information_job_get($params, function($data){
            nurseslounge_job_jobDetail.information_know_more($params, $data);
            nurseslounge_job_jobDetail.information_rating($params, $data);
            nurseslounge_job_jobDetail.information_request_edit($params, $data);
            try{
                google.maps.event.addListener(window, "load", nurseslounge_job_jobDetail.information_location_map($data));
            }catch (e) {

            }
            if(cback != undefined){
                cback($data);
            }
        });
        nurseslounge_job_jobDetail.information_meet_our_recruiters(function($config){
            nurseslounge_lounge_overview.information_meet_our_recruiters_engine($config);
        });
        nurseslounge_job_jobDetail.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    information_job_get:function($params, cback){
        $.ajax({
            url: "/job/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-job-information-edit-modal").modal('hide');
                    $("#nurseslounge-job-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_know_more:function($params, $data){
        var $isEmail = $data && $data.data && $data.data.job && $data.data.job.contact_is_email ? $data.data.job.contact_is_email : false;
        var $contactEmailUrl = $data && $data.data && $data.data.job && $data.data.job.contact_email_url ? $data.data.job.contact_email_url : false;
        var $title = $data && $data.data && $data.data.job && $data.data.job.title ? $data.data.job.title : null;
        var $loungeLink = $data && $data.data && $data.data.job && $data.data.job.lounge && $data.data.job.lounge.link ? $data.data.job.lounge.link : null;
        var $jobInformation = $("#nurseslounge-job-information");
        var $jobInformationRight = $jobInformation.find('.nurseslounge-job-information-right:first');
        var $requestInfo = $jobInformationRight.find(".know-more .option[data-action='request-info']");
        var $jobInformationLeft = $jobInformation.find('.nurseslounge-job-information-left:first');
        var $applyOnWebsite = $jobInformationLeft.find(".apply-on-website");
        var $whyWorkHere = $jobInformationLeft.find(".why-work-here");
        var $body = 'I saw your job on Nurses Lounge and would like to apply.';
        var $subject = 'Application for '+$title+' - via Nurses Lounge';
        $whyWorkHere.unbind().click(function(){
            router.navigate($loungeLink,true);
        }).html('Why Work Here').removeClass('disabled');
        $requestInfo.unbind().click(function(){
            nurseslounge_job_jobDetail.information_request_info_events($params, $data);
        });
        $applyOnWebsite.unbind().click(function(){
            nurseslounge_job_jobDetail.information_apply_set('apply', $params,function($data){
                var $statistics = $jobInformationRight.find('.statistics:first');
                libs.refreshBoxFrom($statistics, $params, function(){
                    if($isEmail){
                        window.open('mailto:'+$contactEmailUrl+'?body='+$body+'&subject='+$subject, '_blank');
                    }else{
                        window.open($contactEmailUrl, '_blank');
                    }
                });
            });
        }).html('Apply on Website').removeClass('disabled');
    },
    information_apply_set:function($action, $params, cback){
        $.ajax({
            url: "/job/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$.extend({},$params, {action:$action}),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-job-information-edit-modal").modal('hide');
                    $("#nurseslounge-job-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_rating:function($params, $data){
        var $typeId = $data.data.job.lounge.lounge_type_id ? $data.data.job.lounge.lounge_type_id : 0;
        var $jobInformation = $("#nurseslounge-job-information");
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $jobInformationRight = $jobInformation.find('.nurseslounge-job-information-right:first');
        var $ratingFirst = $jobInformationRight.find('.rating-stars:first');
        var $ratingCount = $jobInformationRight.find('.rating-count:first');
        var $addReviewFirst = $jobInformationRight.find('.add-review:first');
        var $deleteReviewFirst = $jobInformationRight.find('.delete-review:first');
        $ratingFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_job_jobDetail.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $ratingCount.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_job_jobDetail.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $addReviewFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_job_jobDetail.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $deleteReviewFirst.unbind().click(function(){
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_job_jobDetail.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
    },
    information_location_map:function($data){
        var $location = $data && $data.data && $data.data.job && $data.data.job.location && $data.data.job.location ? $data.data.job.location : null;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-job-information-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    information_request_info_events:function($params, $data){
        var $loungeLink = $data && $data.data && $data.data.job && $data.data.job.lounge && $data.data.job.lounge.link ? $data.data.job.lounge.link : null;
        var $modal = $("#nurseslounge-job-request-info-modal");
        var $container = $modal.find(".request-info-modal-container");
        nurseslounge_job_jobDetail.information_request_info_request($params, function($chtml){
            $container.html('').html($chtml).promise().done(function(){
                $container.find("form input[name='userPhoneNumber']").mask('+(00) 000-000-0000');
                nurseslounge_job_jobDetail.information_request_info_validate(function($form){
                    $params = $.extend({},$params, libs.getObjForm($form));
                    nurseslounge_job_jobDetail.information_apply_set('info', $params, function(){
                        var $jobInformation = $("#nurseslounge-job-information");
                        var $jobInformationRight = $jobInformation.find('.nurseslounge-job-information-right:first');
                        var $statistics = $jobInformationRight.find('.statistics:first');
                        libs.refreshBoxFrom($statistics, $params, function(){
                            $modal.modal('hide');
                        });
                    });
                });
                /*
                var $reviewProfileLink = $modal.find(".review-profile-link");
                $reviewProfileLink.unbind().click(function(){
                    router.navigate($loungeLink,true);
                    $modal.modal('hide');
                });
                 */
                $modal.modal('show');
            });
        });
    },
    information_request_info_request:function($params, cback){
        $.ajax({
            type: 'POST',
            url: '/job/requestInfoView/get',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'error'){
                    $("#nurseslounge-job-information-edit-modal").modal('hide');
                    $("#nurseslounge-job-request-info-modal").modal('hide');
                }
                cback($data);
            }
        });
    },
    information_request_info_validate:function(cback){
        var $validator = $("#nurseslounge-job-request-info-modal form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                jobTitle: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                userName: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                userEmail: {
                    required: true,
                    email:true,
                    minlength: 2,
                    maxlength: 191
                },
                userPhoneNumber: {
                    required: true,
                    minlength: 2,
                    maxlength: 18
                },
                userZipCode: {
                    required: false,
                    minlength: 2,
                    maxlength: 191
                }
            },
            messages: {
                jobTitle: {
                    required: "The job title is required",
                    minlength: "The job title must have at least 2 characters",
                    maxlength: "The job title cannot exceed 600 characters"
                },
                userName: {
                    required: "The user name is required",
                    minlength: "The user name must have at least 2 characters",
                    maxlength: "The user name cannot exceed 600 characters"
                },
                userEmail: {
                    required: "The user email is required",
                    email:"The user email is invalid",
                    minlength: "The user email must have at least 2 characters",
                    maxlength: "The user email cannot exceed 191 characters"
                },
                userPhoneNumber: {
                    required: "The user phone is required",
                    minlength: "The user phone must have at least 2 characters",
                    maxlength: "The user phone cannot exceed 18 characters"
                },
                userZipCode: {
                    required: "The user zip code is not required",
                    minlength: "The user zip code must have at least 2 characters",
                    maxlength: "The user zip code cannot exceed 191 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_request_info_qr:function($params, $loungeLink){
        var $qr = $("#nurseslounge-job-request-info-qr");
        var $form = $qr.find("form");
        $form.find("input[name='userPhoneNumber']").mask('+(00) 000-000-0000');
        nurseslounge_job_jobDetail.information_request_info_qr_validate(function($form){
            nurseslounge_job_jobDetail.information_request_info_qr_set($params, libs.getObjForm($form), function($data){
                window.open($data.data.job_link, '_self');
            });
        });
        /*
        var $reviewProfileLink = $qr.find(".review-profile-link");
        $reviewProfileLink.unbind().click(function(){
            window.open($loungeLink, '_self');
        });
         */
    },
    information_request_info_qr_validate:function(cback){
        var $validator = $("#nurseslounge-job-information-qr form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                jobTitle: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                userName: {
                    required: true,
                    minlength: 2,
                    maxlength: 600
                },
                userEmail: {
                    required: true,
                    email:true,
                    minlength: 2,
                    maxlength: 191
                },
                userPhoneNumber: {
                    required: true,
                    minlength: 2,
                    maxlength: 18
                },
                userZipCode: {
                    required: false,
                    minlength: 2,
                    maxlength: 191
                }
            },
            messages: {
                jobTitle: {
                    required: "The job title is required",
                    minlength: "The job title must have at least 2 characters",
                    maxlength: "The job title cannot exceed 600 characters"
                },
                userName: {
                    required: "The user name is required",
                    minlength: "The user name must have at least 2 characters",
                    maxlength: "The user name cannot exceed 600 characters"
                },
                userEmail: {
                    required: "The user email is required",
                    email:"The user email is invalid",
                    minlength: "The user email must have at least 2 characters",
                    maxlength: "The user email cannot exceed 191 characters"
                },
                userPhoneNumber: {
                    required: "The user phone is required",
                    minlength: "The user phone must have at least 2 characters",
                    maxlength: "The user phone cannot exceed 18 characters"
                },
                userZipCode: {
                    required: "The user zip code is not required",
                    minlength: "The user zip code must have at least 2 characters",
                    maxlength: "The user zip code cannot exceed 191 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_request_info_qr_set:function($params, $form, cback){
        $.ajax({
            url: "/job/information/qr/requestInfo/"+$params.hash+"/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$.extend({},$params, $form),
            success: function ($data) {
                libs.expire($data);
                if(cback != undefined){
                    cback($data);
                }
            }
        });
    },
    //Admin
    information_request_edit:function($params, $data){
        var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
        $credential = $credential.map(function($x){return parseInt($x);});
        var $allowTabs = {
            'job_information':  $.inArray(19, $credential) != -1 ? true : false,
            'job_location':  $.inArray(19, $credential) != -1 ? true : false
        };
        var $allowTabsFiltered = $allowTabs;
        $allowTabs = {};
        $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
        var $information = $("#nurseslounge-job-information");
        var $informationRight = $information.find('.nurseslounge-job-information-right:first .administrator:first');
        var $options = $informationRight.find('.option');
        $options.each(function(){
            var $that = $(this);
            var $action = $that.data('action');
            if(
                $action == 'create' ||
                $action == 'edit' ||
                $action == 'delete'
            ) {
                $that.unbind().click(function () {
                    var $tab = null;
                    $.each($allowTabs, function($i, $v){
                        if($v){
                            $tab = $i;
                            return false;
                        }
                    });
                    if(
                        $tab && $action == 'create' ||
                        $tab && $action == 'edit'
                    ){
                        nurseslounge_job_jobDetail.information_request_select_tab($action, $tab, $allowTabs, $params, function () {
                            $("#nurseslounge-job-information-edit-modal").scrollTop(0);
                            $("#nurseslounge-job-information-edit-modal").modal('show');
                        });
                    }else
                    if($action == 'delete'){
                        if(confirm('Are you sure you want to delete this job?')){
                            $params = $.extend({},$params, {action:$action,tab:$tab});
                            nurseslounge_job_jobDetail.information_apply_set($action, $params, function($data){
                                if($data.status == 'success'){
                                    router.navigate('/lounge/'+$data.data.key);
                                }
                            });
                        }
                    }
                });
            }
        });
    },
    information_request_select_tab:function($action, $tab, $allowTabs, $params, cback){
        nurseslounge_job_jobDetail.information_request_tabs_events($action, $tab, $allowTabs, $params,function(){
            $params = $.extend({},$params, {user_id:libs.memoryGet('user_id'), tab:$tab, action:$action});
            nurseslounge_job_jobDetail.information_request_load($tab, $params, function(){
                switch ($tab) {
                    case 'job_information':
                        nurseslounge_job_jobDetail.information_job_get($params, function($data){
                            nurseslounge_job_jobDetail.information_request_tab_information($action, $tab, $allowTabs, $params, $data, cback);
                        });
                        break;
                    case 'job_location':
                        nurseslounge_job_jobDetail.information_job_get($params, function($data){
                            nurseslounge_job_jobDetail.information_request_tab_location($action, $tab, $allowTabs, $params, $data, cback);
                        });
                        break;

                }
            });
        });
    },
    information_request_tabs_events:function($action, $tab, $allowTabs, $params, cback){
        //Disable All
        $('#nurseslounge-job-information-edit-modal .nav-pills .nav-link').addClass('disabled').removeClass('active');
        $('#nurseslounge-job-information-edit-modal .job-information-modal-container .tab-pane .container').html('');
        //Events
        $('#nurseslounge-job-information-edit-modal .nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, Object.keys($allowTabs)) > -1){
                nurseslounge_job_jobDetail.information_request_select_tab($action, $selectedTab, $allowTabs, $params, function(){
                    $("#nurseslounge-job-information-edit-modal").scrollTop(0);
                });
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $('#nurseslounge-job-information-edit-modal .nav-pills .nav-link[data-target="#'+$i+'"]').removeClass('disabled');
        });
        $('#nurseslounge-job-information-edit-modal .nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if($action == 'create'){
            $("#nurseslounge-job-information-edit-modal .modal-title").html('Create');
        }
        if($action == 'edit'){
            $("#nurseslounge-job-information-edit-modal .modal-title").html('Edit');
        }
        if(cback != undefined){
            cback();
        }
    },
    information_request_load:function($tab, $params, cback){
        nurseslounge_job_jobDetail.information_request_edit_view_get($tab, $params, function($chtml){
            var $images = $($chtml).find('img');
            libs.checkImageLoad($images, function(){
                $("#"+$tab+" .container").html($chtml).promise().done(function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            });
        });
    },
    information_request_edit_view_get:function($tab, $params, cback){
        $params = $.extend({},$params,{user_id:libs.memoryGet('user_id'),tab:$tab});
        $.ajax({
            type: 'POST',
            url: '/job/informationView/get',
            data: $params,
            method: "POST",
            cache:false,
            dataType: "html",
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },

    information_request_tab_information:function($action, $tab, $allowTabs, $params, $data, cback){
        var $job = $data && $data.data && $data.data.job ? $data.data.job : null;
        var $jobListingType = $data && $data.data && $data.data.job_listing_type ? $data.data.job_listing_type : null;
        var $jobEmployerType = $data && $data.data && $data.data.job_employer_type ? $data.data.job_employer_type : null;
        var $location = $data && $data.data && $data.data.job && $data.data.job.location ? $data.data.job.location : null;
        var $modal = $('#nurseslounge-job-information-edit-modal');
        var $information = $modal.find('.job-information-modal-container #job_information .container');
        var $informationForm = $information.find('form:first');
        var $description = $informationForm.find('.description');
        var $jobListingTypeOptions = '';
        $jobListingTypeOptions += '<option value="">Select a Job Type</option>';
        $.each($jobListingType, function($i, $v){
            $jobListingTypeOptions += '<option value="'+$i+'">'+$v+'</option>';
        });
        var $jobEmployerTypeOptions = '';
        $jobEmployerTypeOptions += '<option value="">Choose an Employer Type</option>';
        $.each($jobEmployerType, function($i, $v){
            $jobEmployerTypeOptions += '<option value="'+$i+'">'+$v+'</option>';
        });
        $informationForm.find("select[name='jobListingType']").html($jobListingTypeOptions);
        $informationForm.find("select[name='jobEmployerType']").html($jobEmployerTypeOptions).promise().done(function(){
            nurseslounge_job_jobDetail.information_request_tab_information_validate(function($form){
                var $formObj = libs.getObjForm($form);
                var $formDescription = $description.summernote('code');
                var $newParams = $.extend({},$params, $formObj);
                $newParams = $.extend({},$newParams, {description:$formDescription,tab:$tab});
                nurseslounge_job_jobDetail.information_apply_set($action, $newParams, function($data){
                    var $action = $data.data.action;
                    var $jobKey = $data.data.job_key;
                    $params = $.extend({},$params, {job_key:$jobKey,action:$action});
                    if($data.status == 'success'){
                        if($newParams.action == 'create'){
                            router.navigate($data.data.job_link,true);
                            nurseslounge_job_jobDetail.init($params, function($data){
                                nurseslounge_job_jobDetail.information_request_select_tab($action, $tab, $allowTabs, $params, cback);
                            });
                        }
                        if($newParams.action == 'edit'){
                            libs.refreshBoxFrom('.page-contents', $params, function(){
                                nurseslounge_job_jobDetail.init($params, function($data){
                                    nurseslounge_job_jobDetail.information_request_select_tab($action, $tab, $allowTabs, $params, cback);
                                });
                            });
                        }
                    }else{
                        $modal.modal('hide');
                    }
                });
            });
            try{
                $description.summernote('destroy');
            }catch (e) {

            }
            var $stripTags = function ($context) {
                var $ui = $.summernote.ui;
                var $button = $ui.button({
                    contents: 'Remove Formatting',
                    tooltip: 'Strip Tags',
                    click: function () {
                        var $text = [];
                        var $code = $description.summernote("code");
                        $($code).each(function(){
                            $text.push('<p>'+$(this).text()+'</p>');
                        });
                        $code = $text.join('');
                        $description.summernote("code", $code);
                    }
                });
                return $button.render();
            }
            $description.summernote({
                placeholder: 'Description ...',
                height: '400px',
                width: '100%',
                focus: true,
                disableResizeEditor: true,
                dialogsInBody: true,
                dialogsFade: true,
                codeviewFilter: true,
                codeviewIframeFilter: true,
                spellCheck: true,
                disableGrammar: false,
                styleTags: [
                    'p',
                    'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
                ],
                fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
                fontSizeUnits: ['pt', 'px'],
                toolbar: [
                    ['style', ['style']],
                    ['font', ['fontname', 'fontsize', 'fontsizeunit']],
                    ['font', ['forecolor', 'backcolor']],
                    ['font', ['bold', 'italic', 'underline']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['para', ['height']],
                    ['stripTags', ['stripTags']]
                ],
                buttons: {
                    stripTags: $stripTags
                }
            });
            if($job.internal_id) {
                $informationForm.find("input[name='jobInternalId']").val($job.internal_id);
            }
            if($job.title) {
                $informationForm.find("input[name='jobTitle']").val($job.title);
            }
            if($job.signing_bonus) {
                $informationForm.find("input[name='jobSigningBonus']").val($job.signing_bonus);
            }
            if($job.education_level) {
                $informationForm.find("input[name='jobEducationLevel']").val($job.education_level);
            }
            if($job.years_of_experience) {
                $informationForm.find("input[name='jobYearsOfExperience']").val($job.years_of_experience);
            }
            if($job.listing_type_id) {
                $informationForm.find("select[name='jobListingType']").val($job.listing_type_id);
            }
            if($job.employer_type_id) {
                $informationForm.find("select[name='jobEmployerType']").val($job.employer_type_id);
            }
            if($job.shift) {
                $informationForm.find("input[name='jobShift']").val($job.shift);
            }
            if($job.shift_length) {
                $informationForm.find("input[name='jobShiftLength']").val($job.shift_length);
            }
            if($job.schedule) {
                $informationForm.find("input[name='jobSchedule']").val($job.schedule);
            }
            if($job.compensation) {
                $informationForm.find("input[name='jobCompensation']").val($job.compensation);
            }
            if($job.contact_email_url) {
                $informationForm.find("input[name='jobContactEmailUrl']").val($job.contact_email_url);
            }
            if($job.description) {
                $description.summernote('code', $job.description);
            }
            if($location && $location.name) {
                $informationForm.find('input[name="jobEmployerName"]').val($location.name);
            }
        });
        if(cback != undefined){
            cback();
        }
    },
    information_request_tab_information_validate:function(cback){
        var $validator;
        try {
            $validator = $("#job_information form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#job_information form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                jobEmployerName: {
                    required: true,
                    minlength: 3,
                    maxlength: 600
                },
                jobTitle: {
                    required: true,
                    minlength: 3,
                    maxlength: 600
                },
                jobInternalId: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobSigningBonus: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobEducationLevel: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobYearsOfExperience: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobListingType: {
                    required: true
                },
                jobEmployerType: {
                    required: true
                },
                jobShift: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobShiftLength: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobSchedule: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobCompensation: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobContactEmailUrl: {
                    required: true,
                    minlength: 3,
                    maxlength: 600
                },
            },
            messages: {
                jobEmployerName: {
                    required: "The job employer name is required",
                    minlength: "The job employer name must have at least 3 characters",
                    maxlength: "The job employer name cannot exceed 600 characters"
                },
                jobTitle: {
                    required: "The job title is required",
                    minlength: "The job title must have at least 3 characters",
                    maxlength: "The job title cannot exceed 600 characters"
                },
                jobInternalId: {
                    required: "The job internal id is not required",
                    minlength: "The job internal must have at least 3 characters",
                    maxlength: "The job internal cannot exceed 600 characters"
                },
                jobSigningBonus: {
                    required: "The job signing bonus is not required",
                    minlength: "The job signing bonus must have at least 3 characters",
                    maxlength: "The job signing bonus cannot exceed 600 characters"
                },
                jobEducationLevel: {
                    required: "The job education level is not required",
                    minlength: "The job education level must have at least 3 characters",
                    maxlength: "The job education level cannot exceed 600 characters"
                },
                jobYearsOfExperience: {
                    required: "The job years of experience is not required",
                    minlength: "The job years of experience must have at least 3 characters",
                    maxlength: "The job years of experience cannot exceed 600 characters"
                },
                jobListingType: {
                    required: "The job listing type is required"
                },
                jobEmployerType: {
                    required: "The job employer type is required"
                },
                jobShift: {
                    required: "The job shift is not required",
                    minlength: "The job shift must have at least 3 characters",
                    maxlength: "The job shift cannot exceed 600 characters"
                },
                jobShiftLength: {
                    required: "The job shift length is not required",
                    minlength: "The job shift length have at least 3 characters",
                    maxlength: "The job shift length cannot exceed 600 characters"
                },
                jobSchedule: {
                    required: "The job schedule is not required",
                    minlength: "The job schedule have at least 3 characters",
                    maxlength: "The job schedule cannot exceed 600 characters"
                },
                jobCompensation: {
                    required: "The job compensation is not required",
                    minlength: "The job compensation have at least 3 characters",
                    maxlength: "The job compensation cannot exceed 600 characters"
                },
                jobContactEmailUrl: {
                    required: "The job contact email or url is required",
                    minlength: "The job contact email or url have at least 3 characters",
                    maxlength: "The job contact email or url cannot exceed 600 characters"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },

    information_request_tab_location:function($action, $tab, $allowTabs, $params, $data, cback){
        var $location = $data && $data.data && $data.data.job && $data.data.job.location ? $data.data.job.location : null;
        var $states = $data && $data.data && $data.data.states ? $data.data.states :null;
        var $addressStateId = $data && $data.data && $data.data.address_state_id ? $data.data.address_state_id : null;
        var $modal = $('#nurseslounge-job-information-edit-modal');
        var $jobLocation = $modal.find('.job-information-modal-container #job_location .container');
        var $jobLocationForm = $jobLocation.find('form:first');
        var $stateChtml = '';
        $stateChtml += '<option value="">Select the job state</option>';
        $.each($states, function($i, $v){
            $stateChtml += '<option value="'+$i+'">'+$v+'</option>';
        });
        $jobLocationForm.find('select[name="jobState"]').html($stateChtml).promise().done(function(){
            nurseslounge_job_jobDetail.information_request_tab_location_validate(function($form){
                var $formObj = libs.getObjForm($form);
                var $newParams = $.extend({},$params, $formObj);
                $newParams = $.extend({},$newParams, {tab:$tab});
                nurseslounge_job_jobDetail.information_apply_set($action, $newParams, function($data){
                    var $action = $data.data.action;
                    var $jobKey = $data.data.job_key;
                    $params = $.extend({},$params, {job_key:$jobKey,action:$action});
                    if($data.status == 'success'){
                        router.navigate($data.data.job_link,true);
                        nurseslounge_job_jobDetail.init($params, function($data){
                            nurseslounge_job_jobDetail.information_request_select_tab($action, $tab, $allowTabs, $params, cback);
                        });
                    }else{
                        $modal.modal('hide');
                    }
                });
            });
            if($location && $location.facility) {
                $jobLocationForm.find('input[name="jobFacility"]').val($location.facility);
            }
            if($location && $location.address_street) {
                $jobLocationForm.find('input[name="jobStreet"]').val($location.address_street);
            }
            if($location && $location.address_city) {
                $jobLocationForm.find('input[name="jobCity"]').val($location.address_city);
            }
            if($addressStateId) {
                $jobLocationForm.find('select[name="jobState"]').val($addressStateId);
            }
            if($location && $location.address_zip_code) {
                $jobLocationForm.find('input[name="jobZipCode"]').val($location.address_zip_code);
            }
            if($location && $location.address_latitude && $location.address_longitude) {
                nurseslounge_job_jobDetail.information_request_tab_location_map($location, function () {
                    if ($location.address_is_unmappable == 0) {
                        $jobLocationForm.find('.lat').html($location.address_latitude).show();
                        $jobLocationForm.find('.lng').html($location.address_longitude).show();
                        $jobLocationForm.find('#job-edit-location-map').show();
                    } else {
                        $jobLocationForm.find('.lat').hide();
                        $jobLocationForm.find('.lng').hide();
                        $jobLocationForm.find('#job-edit-location-map').hide();
                    }
                });
            }
        });
        if(cback != undefined){
            cback();
        }
    },
    information_request_tab_location_validate:function(cback){
        var $validator;
        try {
            $validator = $("#job_location form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#job_location form").validate({
            onsubmit: true,
            debug: true,
            ignore: '*:not(.validate)',
            rules: {
                jobFacility: {
                    required: true,
                    minlength: 3,
                    maxlength: 600
                },
                jobStreet: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobCity: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                },
                jobState: {
                    required: true
                },
                jobZipCode: {
                    required: false,
                    minlength: 3,
                    maxlength: 600
                }
            },
            messages: {
                jobFacility: {
                    required: "The job facility is required",
                    minlength: "The job facility must have at least 3 characters",
                    maxlength: "The job facility cannot exceed 600 characters"
                },
                jobStreet: {
                    required: "The job street is not required",
                    minlength: "The job street must have at least 3 characters",
                    maxlength: "The job street cannot exceed 600 characters"
                },
                jobCity: {
                    required: "The job city is not required",
                    minlength: "The job city must have at least 3 characters",
                    maxlength: "The job city cannot exceed 600 characters"
                },
                jobState: {
                    required: "The job state is required"
                },
                jobZipCode: {
                    required: "The job zip code is not required",
                    minlength: "The job zip code must have at least 3 characters",
                    maxlength: "The job zip code cannot exceed 600 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    information_request_tab_location_map:function($location, cback){
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            try{
                var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
                var $iconUrl =  './../../../../bimg/NursesLounge/active.png';
                var $map = new google.maps.Map(document.getElementById('job-edit-location-map'), {
                    center:$position,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoom: 15
                });
                $map.setTilt(0);
                var $marker = new google.maps.Marker({
                    position:$position,
                    map: $map,
                    animation: google.maps.Animation.DROP,
                    icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
                });
            }catch (e) {

            }
        }
        if(cback != undefined){
            cback();
        }
    },
    //Meet our recruiters
    information_meet_our_recruiters:function(cback){
        cback({
            'container':$("#nurseslounge-job-information .nurseslounge-job-information-right .meet-our-recruiters")
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-job-information .nurseslounge-job-information-right .banners")
        });
    },
};
